module.exports = __webpack_public_path__ + "img/1.756df704.jpg";